import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap'
import Select from 'react-select'
import { toDealStatusSelect } from '../serializers'
import s from './DealsModal.scss'

const DealsModal = ({
  setIsDealsModalVisible,
  isDealsModalVisible,
  changeDealStatus,
  stages,
  deleteStage,
  stage
}) => {
  return (
    <>
      <Modal
        keyboard={false}
        backdrop="static"
        isOpen={isDealsModalVisible}
        toggle={() => {
          setIsDealsModalVisible(!isDealsModalVisible)
        }}
        size="m"
      >
        <ModalHeader
          toggle={() => {
            setIsDealsModalVisible(!isDealsModalVisible)
          }}
          className={s.modalHeader}
        >
          Delete Pipeline Stage
        </ModalHeader>
        <ModalBody className={s.modalBody}>
          <div className={s.content}>
            {stage.deals.length ? (
              <>
                <div>
                  This is a list of deals with this status. Please choose a different status for
                  them before deleting the current status.
                </div>
                {stage.deals.map(deal => (
                  <div key={`deal-${deal.id}`}>
                    <span>{deal.name}</span>
                    <Select
                      onChange={value => changeDealStatus(value.value, deal)}
                      options={toDealStatusSelect(stages, deal.status)}
                      className={s.select}
                    />
                  </div>
                ))}
              </>
            ) : (
              <div>
                There are no deals with this status. You can delete it. Are you sure you want to
                Delete this status?
              </div>
            )}
          </div>
        </ModalBody>
        <ModalFooter>
          <Button
            className={s.saveBtn}
            disabled={!!stage.deals.filter(d => d.status === stage?.code).length}
            onClick={deleteStage}
            data-cy="delete_stage_btn"
          >
            {!!stage.deals.length && 'Change Statuses & '}Delete Pipeline Stage
          </Button>
          <Button color="secondary" onClick={() => setIsDealsModalVisible(!isDealsModalVisible)}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </>
  )
}

export default DealsModal
